import { useState, Suspense, lazy } from 'react';
import LandingPage from './components/LandingPage';
import GuidePage from './components/GuidePage';
import { useLanguage } from './i18n/LanguageContext';

const BideshaEligibilityChecker = lazy(() => import('./components/BideshaEligibilityChecker'));

function CheckerFallback() {
  const { t } = useLanguage();
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: "'Outfit', sans-serif",
        color: '#4A7A70',
        background: '#F4F9F8',
      }}
    >
      {t('loading_app')}
    </div>
  );
}

function App() {
  const [view, setView] = useState('landing'); // 'landing' | 'checker' | 'guide'
  const [guideTarget, setGuideTarget] = useState(null);

  if (view === 'checker') {
    return (
      <Suspense fallback={<CheckerFallback />}>
        <BideshaEligibilityChecker onBack={() => setView('landing')} />
      </Suspense>
    );
  }

  if (view === 'guide') {
    return (
      <GuidePage
        initialSection={guideTarget}
        onStart={() => setView('checker')}
        onBack={() => setView('landing')}
      />
    );
  }

  return (
    <LandingPage
      onStart={() => setView('checker')}
      onGuide={(sectionId) => {
        setGuideTarget(sectionId || null);
        setView('guide');
      }}
    />
  );
}

export default App;
